import { Node, mergeAttributes } from '@tiptap/core';

/**
 * A merge-field "chip" in a contract: an atomic inline node that stands for one
 * template field (a Bullhorn value filled in at send time).
 *
 * Stored as <span data-merge-field="<field id>">Label</span>. No tag syntax is
 * ever shown to or typed by the user — they select text and pick a field.
 * The server sanitiser keeps exactly this span and nothing else on it.
 */
export const MergeField = Node.create({
  name: 'mergeField',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      fieldId: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-merge-field'),
        renderHTML: (attrs) => (attrs.fieldId ? { 'data-merge-field': attrs.fieldId } : {}),
      },
      // Display text only; comes back from the span's text content on reload.
      label: {
        default: '',
        parseHTML: (el) => el.textContent || '',
        renderHTML: () => ({}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-merge-field]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), node.attrs.label || ' '];
  },
});

export default MergeField;
